/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'edit': {
    width: 9,
    height: 10,
    viewBox: '0 0 9 10',
    data: '<path pid="0" _fill="#FFF" fill-opacity=".8" fill-rule="evenodd" d="M7.382 3.5L5.715 1.833 6.746.801a.786.786 0 011.111 0l.556.558a.785.785 0 010 1.11L7.382 3.5zm-.556.556L2.668 8.215 1 6.547 5.16 2.39l1.666 1.666zM.248 9.24A.201.201 0 01.005 9l.422-1.916L2.123 8.78l-1.875.46z"/>'
  }
})
